<template>
  <Card theme="border" class="bid-create-signing" :class="{ 'bid-create-signing--active': current }">
    <template #header>
      <h1>{{ $t('bidSigning') }}</h1>
    </template>
    <template #default>
      <Loader :value="promise" theme="default" :message="$t('loading', { resource: $t('bidContract').toLowerCase() })">
        <div class="row center wrap g-1">
          <ApplicantCard v-for="(item, index) in signers" :value="item" theme="border" :key="index">
            <template #footer>
              <ButtonComponent
                :label="$t(item.signed ? 'signed' : 'sign')"
                :theme="item.signed ? 'success' : 'primary'"
                :icon="item.signed ? 'check-circle' : ['fal', 'angle-right']"
                @click="startSigning(item)"
              />
            </template>
          </ApplicantCard>
        </div>
      </Loader>
    </template>
  </Card>
</template>

<script>
import { i18n } from '@/i18n'
import { mapState } from 'vuex'
import BidAPI from '@/api/Bid'
import Card from '@/components/Card'
import ApplicantCard from '@/components/Applicant'
import { Clone, GetJwtPayload } from '@/utils'
import { Initials } from '@/filters'

const meta = {
  order: 3,
  id: 'signing',
  label: i18n.tc('bidSigning'),
  icon: ['fal', 'file-alt'],
}

export { meta }
export default {
  props: {
    value: Object,
    labels: Object,
    validator: Object,
    isActive: Boolean,
  },
  watch: {
    isActive: {
      handler: 'onActive',
      immediate: true,
    },
    allSigned: {
      handler(val) {
        if (!val) return

        this.$emit('update:isValid', true)
        this.$emit('completed')
        return this.$emit('next')
      },
      immediate: true,
    },
  },
  data() {
    return {
      promise: null,
      current: null,
    }
  },
  computed: {
    ...mapState('Residential', ['item']),
    signers() {
      let res = []

      if (this.value.applicant.signUrl) res.push(this.value.applicant)
      if (this.value.coApplicant.signUrl) res.push(this.value.coApplicant)

      return res
    },
    allSigned() {
      if (!this.signers.length) return false

      return this.signers.every(s => s.signed)
    },
  },
  methods: {
    onActive(state) {
      if (this.value.id || !state) return
      if (this.$route.query['idfy-jwt']) return
      let data = Clone(this.value)

      if (!data.hasCoApplicant) delete data.coApplicant

      this.promise = BidAPI.mutate({ reference: this.item.id, data }, { transformPayload: false }).then(bid => {
        this.value.id = bid.id

        if (['signed', 'accepted'].includes(bid.status)) {
          this.$emit('completed')
          return this.$emit('next')
        }

        this.$set(this.value.applicant, 'signUrl', bid.data.applicant.signUrl)
        this.$set(this.value.applicant, 'signerId', bid.data.applicant.signerId)
        if (data.hasCoApplicant) {
          this.$set(this.value.coApplicant, 'signUrl', bid.data.coApplicant.signUrl)
          this.$set(this.value.coApplicant, 'signerId', bid.data.coApplicant.signerId)
        }
      })
    },
    startSigning(signer) {
      if (!signer.signUrl || signer.signed) return
      this.current = signer

      window.location.href = signer.signUrl
    },
    parseJwt() {
      if (!this.$route.query['idfy-jwt']) return

      const token = GetJwtPayload(this.$route.query['idfy-jwt'])
      this.$router.replace({ query: { ...this.$route.query, ['idfy-jwt']: undefined } })
      if (!token.SignSuccess) return
      const signer = this.signers.find(s => s.signerId === token.ExternalSignerId)
      if (!signer) return this.$emit('next')
      this.$set(signer, 'signed', true)
    },
  },
  created() {
    this.parseJwt()
  },
  filters: {
    Initials,
  },
  components: {
    Card,
    ApplicantCard,
  },
}
</script>

<style lang="scss">
.bid-create-signing {
  margin: 0 auto;

  &--active {
    .card__content {
      padding: 0;
    }
  }

  iframe {
    width: 100%;
    height: 800px;
  }

  .card__header {
    min-height: 125px;
  }

  h1 {
    margin: 0;
  }
}
</style>
